import React from 'react'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'

import Main from 'app/PemetaanKompetensiPage/pages/Main'
import PageHeader from 'app/PemetaanKompetensiPage/components/PageHeader'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer }, // will be passed to the page component as props
  }
}

const PemetaanKompetensiIndex = ({ currentDateTimeServer }) => {
  return <Main currentDateTimeServer={currentDateTimeServer} />
}

const PemetaanKompetensiHomePageHeader = () => {
  const router = useRouter()
  return (
    <PageHeader
      title="Uji Kompetensi"
      leftActionFunction={() => {
        historyUtils.backToApp(() => router.replace('/home'))
      }}
    />
  )
}

PemetaanKompetensiIndex.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: PemetaanKompetensiHomePageHeader,
}

export default PemetaanKompetensiIndex
